class ArticleReadingProgress extends HTMLElement {
  connectedCallback() {
    this.#target = document.getElementById(this.getAttribute("observes"));

    if (!this.#target) {
      return;
    }

    this.#bar = this.querySelector(".article-reading-progress__bar");
    this.#onUpdate = this.#throttle(this.#update.bind(this));

    this.#onUpdate();
    window.addEventListener("scroll", this.#onUpdate, { passive: true });
    window.addEventListener("resize", this.#onUpdate);
    document.addEventListener("shopify:section:load", this.#onUpdate);
    this.removeAttribute("aria-hidden");
    this.classList.add("is-visible");
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.#onUpdate);
    window.removeEventListener("resize", this.#onUpdate);
    document.removeEventListener("shopify:section:load", this.#onUpdate);
  }

  #target;
  #bar;
  #onUpdate;
  #ticking = false;

  #throttle(callback) {
    return () => {
      if (this.#ticking) {
        return;
      }

      this.#ticking = true;

      requestAnimationFrame(() => {
        callback();
        this.#ticking = false;
      });
    };
  }

  #update() {
    this.style.top = getComputedStyle(document.documentElement).getPropertyValue("--sticky-area-height").trim() || "0px";

    const rect = this.#target.getBoundingClientRect();
    const scrollTop = window.scrollY;
    const start = scrollTop + rect.top;
    const end = start + this.#target.offsetHeight;
    const viewportBottom = scrollTop + window.innerHeight;
    const scrollable = end - start - window.innerHeight;
    let progress = 0;

    if (scrollable <= 0) {
      progress = viewportBottom >= start ? 1 : 0;
    } else {
      progress = (scrollTop - start) / scrollable;
    }

    progress = Math.max(0, Math.min(1, progress));
    this.style.setProperty("--scroll-progress", progress.toFixed(4));
    this.#bar?.setAttribute("aria-valuenow", String(Math.round(progress * 100)));
  }
}

if (!window.customElements.get("article-reading-progress")) {
  window.customElements.define("article-reading-progress", ArticleReadingProgress);
}
